'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = profileService;

var _merge = require('lodash/merge');

var _merge2 = _interopRequireDefault(_merge);

var _qs = require('qs');

var _qs2 = _interopRequireDefault(_qs);

var _stringFormat = require('string-format');

var _stringFormat2 = _interopRequireDefault(_stringFormat);

var _tuneInRequest = require('../tuneInRequest');

var _tuneInRequest2 = _interopRequireDefault(_tuneInRequest);

var _gqlRequest = require('../gqlRequest');

var _gqlRequest2 = _interopRequireDefault(_gqlRequest);

var _user = require('../queries/user');

var _user2 = _interopRequireDefault(_user);

var _me = require('../transforms/me');

var _me2 = _interopRequireDefault(_me);

var _transformNowPlayingResponseData = require('../utils/transformNowPlayingResponseData');

var _transformNowPlayingResponseData2 = _interopRequireDefault(_transformNowPlayingResponseData);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function profileService(config, apiContext, applyReauth) {
  var meEndpoint = config.domains.api + '/profiles/me';
  var meFollowsEndpoint = meEndpoint + '/follows';
  var apiEndpoint = config.domains.api + '/profiles';
  var feedEndpoint = config.domains.feed + '/profiles';
  var v3ApiEndpoint = (0, _stringFormat2.default)('{api}/profiles/{{}}/contents', config.domains);
  var proxyEndpoint = (0, _stringFormat2.default)('{local}/proxy', config.domains);
  var graphQlUrl = config.domains.graphQl + '/query';

  function get(guideId) {
    return (0, _tuneInRequest2.default)({
      method: 'get',
      url: apiEndpoint + '/' + guideId,
      noAuthHeader: true
    }, apiContext);
  }

  function getV3(guideId, params) {
    return (0, _tuneInRequest2.default)({
      method: 'get',
      url: (0, _stringFormat2.default)(v3ApiEndpoint, guideId),
      params: params
    }, apiContext);
  }

  function search(term, params) {
    return (0, _tuneInRequest2.default)({
      method: 'get',
      url: apiEndpoint,
      params: (0, _merge2.default)({ fullTextSearch: true, query: term }, params)
    }, apiContext);
  }

  function prepopulateSearch(term, params) {
    return (0, _tuneInRequest2.default)({
      method: 'get',
      url: apiEndpoint,
      params: (0, _merge2.default)({ isPrepopulateSearch: true, query: term }, params)
    }, apiContext);
  }

  function nowPlaying(guideId, params) {
    return (0, _tuneInRequest2.default)({
      method: 'get',
      url: feedEndpoint + '/' + guideId + '/nowPlaying',
      transformResponse: _transformNowPlayingResponseData2.default,
      params: params
    }, apiContext);
  }

  function proxyNowPlaying(guideId, params) {
    return (0, _tuneInRequest2.default)({
      method: 'get',
      url: proxyEndpoint + '/' + guideId + '/nowPlaying',
      transformResponse: _transformNowPlayingResponseData2.default,
      params: params
    }, apiContext);
  }

  function topics(programGuideId, params) {
    return (0, _tuneInRequest2.default)({
      method: 'get',
      url: (0, _stringFormat2.default)(v3ApiEndpoint, programGuideId) + '/topics',
      params: params
    }, apiContext);
  }

  function userByName(userIdentifier) {
    return (0, _tuneInRequest2.default)({
      method: 'get',
      url: apiEndpoint + '/' + userIdentifier + '/follows',
      params: {
        aliastype: 'username'
      }
    }, apiContext);
  }

  function userById(userIdentifier, params) {
    return (0, _tuneInRequest2.default)({
      method: 'get',
      url: apiEndpoint + '/' + userIdentifier + '/follows',
      params: params
    }, apiContext);
  }

  function favorites(username) {
    return (0, _tuneInRequest2.default)({
      method: 'get',
      url: meFollowsEndpoint,
      params: {
        username: username
      }
    }, apiContext);
  }

  function favoritesFolder(username, folderId) {
    return (0, _tuneInRequest2.default)({
      method: 'get',
      url: meFollowsEndpoint,
      params: {
        username: username,
        folderId: folderId,
        filter: 'favorites'
      }
    }, apiContext);
  }

  function getMeWithFavorites() {
    return (0, _tuneInRequest2.default)({
      method: 'get',
      url: meFollowsEndpoint
    }, apiContext);
  }

  function getMe() {
    if (apiContext.isGraphQlEnabled) {
      return (0, _gqlRequest2.default)({
        url: graphQlUrl,
        params: {
          query: _user2.default.me,
          transform: _me2.default
        }
      }, apiContext);
    }

    return (0, _tuneInRequest2.default)({
      method: 'get',
      url: meEndpoint
    }, apiContext);
  }

  function saveMe(_ref) {
    var name = _ref.name,
        email = _ref.email,
        isFollowingListPublic = _ref.isFollowingListPublic;

    return (0, _tuneInRequest2.default)({
      method: 'post',
      url: meEndpoint,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      data: _qs2.default.stringify({ name: name, email: email, isFollowingListPublic: isFollowingListPublic })
    }, apiContext);
  }

  function getMeDevices() {
    return (0, _tuneInRequest2.default)({
      method: 'get',
      url: meEndpoint + '/devices/'
    }, apiContext);
  }

  function addMeDevice(registrationCode) {
    return (0, _tuneInRequest2.default)({
      method: 'post',
      url: meEndpoint + '/devices/',
      data: { registrationCode: registrationCode }
    }, apiContext);
  }

  function deleteMeDevice(id) {
    return (0, _tuneInRequest2.default)({
      method: 'delete',
      url: meEndpoint + '/devices/' + id + '/'
    }, apiContext);
  }

  function verifyDevicePin(pinCode) {
    return (0, _tuneInRequest2.default)({
      method: 'get',
      url: meEndpoint + '/deviceGrantSessions/byUserCode/' + pinCode
    }, apiContext);
  }

  function grantAuthToDevice(pinCode) {
    return (0, _tuneInRequest2.default)({
      method: 'put',
      url: meEndpoint + '/deviceGrantSessions/byUserCode/' + pinCode + '/status/granted'
    }, apiContext);
  }

  return {
    get: get,
    getV3: applyReauth(getV3),
    search: applyReauth(search),
    prepopulateSearch: applyReauth(prepopulateSearch),
    nowPlaying: applyReauth(nowPlaying),
    proxyNowPlaying: applyReauth(proxyNowPlaying),
    topics: applyReauth(topics),
    userByName: applyReauth(userByName),
    userById: applyReauth(userById),
    favorites: applyReauth(favorites),
    favoritesFolder: applyReauth(favoritesFolder),
    getMeWithFavorites: applyReauth(getMeWithFavorites),
    getMe: applyReauth(getMe),
    saveMe: applyReauth(saveMe),
    getMeDevices: applyReauth(getMeDevices),
    addMeDevice: applyReauth(addMeDevice),
    deleteMeDevice: applyReauth(deleteMeDevice),
    verifyDevicePin: verifyDevicePin,
    grantAuthToDevice: applyReauth(grantAuthToDevice)
  };
}
//# sourceMappingURL=profile.js.map